export const UserAppStyles = {
	container: {
		maxWidth: 500
	},
	heading: {
		fontSize: 30,
		color: "#646464",
		fontWeight: 700,
		marginBottom: 30,
		marginTop: 70
	},
	text: {
		fontFamily: 'Nunito',
		color: 'grey'
	},
	cardImg: {
		maxWidth: 600,
		maxHeight: 500,
		marginTop: 50
	},
	heading2: {
		fontSize: 20,
		marginBottom: 15,
		marginTop: 30,
		fontWeight: 'bold'
	},
	headText: {
		fontSize: 15,
		lineHeight: 1
	}
};